//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import DeviceModel from './device.model';

@Injectable({
  providedIn: 'root'
})
export class DeviceService extends Service<DeviceModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/aqu/device/');
  }

  public getAllDevices() {
    return new Promise<Array<DeviceModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<DeviceModel>>(`${this.baseUrl}${this.serviceUrl}?pageSize=2000&order=new`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public addDevice(device: DeviceModel) {
    return new Promise<Array<DeviceModel>>((resolve, reject) => {
      const request = this.httpClient.post<Array<DeviceModel>>(`${this.baseUrl}${this.serviceUrl}addDevice`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public fileDownload(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}download`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public ioPorts(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}ioPort`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public addNetwork(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}wifi/addNetwork`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public wifiScan(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}wifi/scan`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public fileUpload(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}upload`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  public autoUpdate(device: DeviceModel) {
    return new Promise<DeviceModel>((resolve, reject) => {
      const request = this.httpClient.post<DeviceModel>(`${this.baseUrl}${this.serviceUrl}update`, device, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
